export default __webpack_public_path__ + "static/media/small_flash.ec85677e.svg";